import { useCallback } from 'react';
import { useRecoilValue } from 'recoil';

import { takeSnapshotState } from 'state/atoms';

interface TakeSnapshotOptions {
  undoRedo?: boolean;
  projectChange?: boolean;
  updateCode?: boolean;
}

const useTakeSnapshot = () => {
  const {
    undoRedo: undoRedoTakeSnapshot,
    projectChange: projectChangeTakeSnapshot,
    updateCode: updateCodeTakeSnapshot,
  } = useRecoilValue(takeSnapshotState);

  const takeSnapshot = useCallback(
    (optionParams?: TakeSnapshotOptions) => {
      const options = {
        undoRedo: true,
        projectChange: true,
        updateCode: true,
        ...optionParams,
      };
      const { undoRedo, projectChange, updateCode } = options;

      if (undoRedo && undoRedoTakeSnapshot) {
        undoRedoTakeSnapshot();
      }
      if (projectChange && projectChangeTakeSnapshot) {
        projectChangeTakeSnapshot();
      }
      if (updateCode && updateCodeTakeSnapshot) {
        updateCodeTakeSnapshot();
      }
    },
    [undoRedoTakeSnapshot, projectChangeTakeSnapshot, updateCodeTakeSnapshot]
  );

  return {
    takeSnapshot,
  };
};

export default useTakeSnapshot;
